import * as React from "react";
import useHeaderMenuStore from '@src/stores/HeaderMenuStore';
import { HeaderSearchResults } from "@src/stories/ecommerce/HeaderSearch/HeaderSearchResults";
import useReactify from "@src/hooks/useReactify";
import { ReactifySearchProvider} from "@usereactify/search";
import {Button} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Button/Button";
import {Link} from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Link/Link";
import { useHeaderHeight } from '@src/hooks/useHeaderHeight';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";

export const SearchBar = ({ settings, type, results }) => {
    const isMobile = useMobileBreakpoint(mobileBreakpoint);
    // console.log("Search bar Reactify", settings?.shop?.domain);
    return (
        <ReactifySearchProvider
            mode="search"
            shopifyPermanentDomain={`${settings?.shop?.domain}`}
            includeFields={[
                "title",
                "handle",
                "variants.option*", // returns variants.option1, variants.option2, etc...
            ]}
        >
            <Search settings={settings} />
        </ReactifySearchProvider>
    );
};

const Search = ({ settings }) => {
    const { reactifySearch,searchResults, totalResults} = useReactify(null);
    const [query, setQuery] = React.useState("");
    const { currentMenu } = useHeaderMenuStore();
    const { height, headerHeight } = useHeaderHeight();
    const isMobile = useMobileBreakpoint(mobileBreakpoint);
    const closeMenu = useHeaderMenuStore((state) => state.closeMenu)

    return  (
        <div
            className={`predictive-search-wrapper flex flex-col bg-white lg:w-[441px] w-full h-full py-[24px] px-4 lg:px-[32px] lg:py-[32px] ${
                currentMenu === "SEARCH" ? "" : "hidden"
            }`}
            x-data="searchheader()"
            style={{
                height: isMobile ? null : height,
                top: isMobile ? headerHeight : null
            }}
        >
            <predictive-search
                // x-data={`${settings.additional.search_type}`}
                // x-init="init({{ search_settings }}, {{ settings.products_per_page }})"
                x-cloak
                aria-modal="true"
                className={`predictive-search__container`}
            >
                <div
                    id="predictive-search-form-wrapper"
                    className="h5 flex max-lg:flex-col justify-center self-center lg:min-h-[56px] w-full bg-white items-start lg:items-center"
                >
                    <button
                        className="predictive-search-form-wrapper__close lg:hidden"
                        onClick={() => closeMenu(isMobile)}
                    >
                        <span className="icon icon-close"></span>
                        <span className="h6">CLOSE</span>
                    </button>
                    {settings.additional.prompt_text && (
                        <h6 className="hidden">{settings.prompt_text}</h6>
                    )}
                    <form
                        action={`${settings.additional.search_url}`}
                        method="get"
                        role="search"
                        className="flex w-full"
                    >
                        <div className="default-input search-input w-full relative">
                            <div className="text-field-wrap has-icon">
                                <input
                                    id="predictive-search-input"
                                    className={"w-full text-black form-field"}
                                    type="search"
                                    name="q"
                                    placeholder={`Type to search`}
                                    onChange={async (e) => {
                                        const newQuery = e.target.value;
                                        setQuery(newQuery);
                                        await reactifySearch(newQuery);
                                    }}
                                    role="combobox"
                                    aria-expanded="false"
                                    aria-owns="predictive-search-results"
                                    aria-controls="predictive-search-results"
                                    aria-haspopup="listbox"
                                    aria-autocomplete="list"
                                />
                                <label
                                    htmlFor="predictive-search-input"
                                    className="sr-only"
                                >
                                    Search
                                </label>

                                <div
                                    htmlFor="predictive-search-input"
                                    className="text-field-icon hidden lg:flex"
                                >
                                    <i
                                        className={`icon icon-arrow-right text-[8px]`}
                                    ></i>
                                </div>

                                <div
                                    x-show="queryInput.length > 0"
                                    x-on:click="clearInput"
                                    htmlFor="predictive-search-input"
                                    className="hidden lg:flex gap-2 items-center cursor-pointer px-0 text-black"
                                ></div>
                            </div>
                        </div>
                        <input name="options[prefix]" type="hidden" value="last" />
                    </form>

                    {/*<span*/}
                    {/*    className="flex h-full border-none pl-[24px]"*/}
                    {/*    x-on:click="$store.global.toggleSearch()"*/}
                    {/*>*/}
                    {/*    <span className="sr-only">Close</span>*/}
                    {/*    <i className={`icon-close w-[16px] h-[16px]`}></i>*/}
                    {/*</span>*/}
                </div>
            </predictive-search>

            <div className={`predictive-search__results h-[80%] flex flex-col space-y-4 mt-[16px]`}>
            {(query && totalResults > 0) && <div className="py-4 hide-scrollbar overflow-x-hidden">
                <HeaderSearchResults
                    settings={settings}
                    results={searchResults?.slice(0, 6)}
                    type={'products'}
                />
            </div>}
                {(query && totalResults > 0) &&
                    <Link classes={`h5 w-full button button-primary lg:flex-none`}
                          link={`/search?q=${query}`}
                    >
                        {`SEE ${totalResults} RESULTS FOR "${query}"`}
                    </Link>
                }
            </div>
        </div>
    )
};
